
import type { PropType, Ref } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        checked: {
            type: Object as PropType<Ref<boolean>>,
            default: false,
        }
    },
    emits: ['change'],
    setup(_, { emit }) {
        const onClick = (event: Event) => {
            emit('change', event)
        }

        return {
            onClick
        }
    }
})
